import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=ee273752&scoped=true"
import script from "./password-reset.vue?vue&type=script&lang=js"
export * from "./password-reset.vue?vue&type=script&lang=js"
import style0 from "./password-reset.vue?vue&type=style&index=0&id=ee273752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee273752",
  null
  
)

export default component.exports